import app from '@/app';

/* @ngInject */
function Probing($resource) {
	return $resource(
		'api/probings/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Probing', Probing);
